"use client";

import React from "react";
import MicrosoftUET from "./MicrosoftUET";
import MetaPixel from "./MetaPixel";

/** DB-backed ids resolved on the server (with NEXT_PUBLIC_* fallback already applied). */
export interface PageScriptConfig {
  kenytBotId?: string | null;
  tawkPropertyId?: string | null;
  tawkWidgetId?: string | null;
  freshdeskToken?: string | null;
  freshdeskHost?: string | null;
  freshdeskWidgetUuid?: string | null;
  upgradChatbotClientKey?: string | null;
  upgradChatbotBotId?: string | null;
  upgradChatbotUrl?: string | null;
  gaId?: string | null;
  adsCode?: string | null;
  gtmId?: string | null;
  metaPixelId?: string | null;
  microsoftUetTagId?: string | null;
  googleAdsConversionId?: string | null;
  rudderStackWriteKey?: string | null;
}

/**
 * The marketing pixels — Meta Pixel and Microsoft UET — on the standard 4,500ms backstop.
 *
 * RudderStack and the chat widget used to live here. Both moved out because each wants a longer
 * delay than these two: app/layout.tsx mounts three groups, each behind its own backstop, and the
 * comment there says which and why. `PageScriptConfig` still carries every id — the other mounts
 * import this type and the same resolved config object is handed to all three.
 */
const PageScript = ({ config }: { config?: PageScriptConfig } = {}) => {
  return (
    <>
      <MicrosoftUET uetTagId={config?.microsoftUetTagId} />
      <MetaPixel pixelId={config?.metaPixelId} />
    </>
  );
};

export default PageScript;
